import React from "react";
import styled from "styled-components";

type Direction = "up" | "down" | "left" | "right";
interface IProps {
  className?: string;
  stroke?: string;
  direction: Direction;
  width?: number;
  height?: number;
}

const SVG = styled.svg<{ stroke: string; direction: Direction }>`
  stroke: ${(props) => props.stroke};
  transform: rotateZ(
    ${(props) => {
      switch (props.direction) {
        case "up":
          return "0deg";
        case "right":
          return "90deg";
        case "down":
          return "180deg";
        case "left":
          return "270deg";
        default:
          return "0deg";
      }
    }}
  );
`;

export const Chevron = ({
  className,
  stroke = "black",
  direction,
  width,
  height,
}: IProps) => {
  const actualWidth = width ?? (height ? (height * 12) / 7 : 12);
  const actualHeight = height ?? (width ? (width * 7) / 12 : 7);

  return (
    <SVG
      width={actualWidth}
      height={actualHeight}
      viewBox="0 0 12 7"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
      direction={direction}
      stroke={stroke}
    >
      <path d="M1 6.00005L6 0.994751L11 6.00005" />
    </SVG>
  );
};
